// extracted by mini-css-extract-plugin
module.exports = {"component":"artists_component_1lWAa","artists":"artists_artists_3-kgl","populated":"artists_populated_2WEqK","actions":"artists_actions_2nGQq"};